<template>
    <div class="reminder-detail-page">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">选择学生</p>
        </div>
        <div class="school-list">
            <div class="school-item"
                 v-for="(item,index) in list"
                 :key="index">
                <div class="school-name">{{item.school_name}}</div>
                <div class="unit-list"
                     v-if="item.units">
                    <div class="unit-item"
                         v-for="(item2,index2) in item.units"
                         :key="index2">
                        <div class="tit">
                            <p>{{item2.unit_name}}</p>
                            <span :class="item2.active?'active':''"
                                  @click="handleChoose(item2)"></span>
                        </div>

                        <transition name="my-slide"
                                    tag="div">
                            <div class="stu-list"
                                 :style="`height:${item2.students.length * 2.1}rem`"
                                 v-show="item2.active">
                                <div class="stu-item"
                                     @click="handleChoose(item3)"
                                     v-for="(item3,index3) in item2.students"
                                     :class="item3.active?'active':''"
                                     :key="index3">{{item3.real_name}}</div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
        <div class="fix-btn">

            <div class="btn"
                 @click="selectStu"><span>确定</span></div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            list: [],
            //从缓存中读取已选择的学生
            stuList: JSON.parse(localStorage.getItem('stuList')),
        }
    },
    created () {
        this.getUnitList()
    },
    methods: {
        getUnitList () {
            this.$http.post(API_URL_JXGT_API + '/message/choose/stu', { is_sf: 1 }).then(res => {
                if (res.data.response == 'ok') {
                    res.data.data.forEach(e => {
                        e.units.forEach(j => {
                            j.active = true
                            j.students.forEach(k => {
                                k.active = false
                            })
                        })
                    })
                    this.list = res.data.data
                    //对比接口返回的学生id和缓存中已勾选的学生id
                    this.list.forEach(e => {
                        e.units.forEach(j => {
                            j.students.forEach(k => {
                                //k：接口返回的学生
                                if (this.stuList) {
                                    this.stuList.forEach(q => {
                                        q.students.forEach(w => {
                                            if (w.active) {
                                                //w：缓存中已勾选的学生
                                                if (w.user_id == k.user_id) {
                                                    k.active = true
                                                }
                                            }
                                        })
                                    })
                                }
                            })
                        })
                    })
                }
            })
        },
        //选中
        handleChoose (item) {
            item.active = !item.active
        },
        //确定
        selectStu () {
            let _arr = []

            this.list.forEach(e => {
                if (e.units.length) {
                    e.units.forEach(j => {
                        //判断该班级下是否有选中学生
                        let index = j.students.findIndex(k => k.active)
                        //如果存在选中的学生，则把该学生存到数组里
                        if (index >= 0) {
                            let _num = 0
                            j.students.forEach(l => {
                                if (l.active) {
                                    _num += 1
                                }
                            })
                            j.activeStu = _num
                            _arr.push(j)
                        }

                    })
                }
            })
            if (!_arr.length) {
                layer.tips('请选择学生')
                return
            }
            localStorage.setItem('stuList', JSON.stringify(_arr))
            localStorage.removeItem('reminderUnits')
            this.$router.go(-2)
        },
    },

}
</script>

<style lang="scss" scoped>
.reminder-detail-page {
    padding-top: 96px / $ppr;
    padding-bottom: 128px / $ppr;
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(../img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }
    .send {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
    .gary {
        color: #e8e8e8;
    }
}
.school-list {
    padding: 24px / $ppr;
    .school-item {
        margin-bottom: 24px / $ppr;
        .school-name {
            color: #5e89ef;
            background: #e8f0fd url("../release/img/icon-school.png") no-repeat
                24px / $ppr center;
            background-size: 42px / $ppr 42px / $ppr;
            padding: 24px / $ppr 24px / $ppr 24px / $ppr 80px / $ppr;
            border-radius: 24px / $ppr 24px / $ppr 0 0;
        }
        .unit-list {
            .unit-item {
                background: #fff;
                padding: 24px / $ppr;
                margin-bottom: 24px / $ppr;
                .tit {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    span {
                        display: inline-block;
                        width: 25px / $ppr;
                        height: 13px / $ppr;
                        background: url("../release/img/icon_close2.png")
                            no-repeat;
                        background-size: 100% 100%;
                    }
                    .active {
                        background: url("../release/img/icon_open2.png")
                            no-repeat;
                        background-size: 100% 100%;
                    }
                }
                .stu-list {
                    height: 0;
                    overflow: hidden;
                    transition: height 0.3s linear;
                    margin-top: 24px / $ppr;
                    .stu-item {
                        padding: 24px / $ppr;
                        border-top: 1px / $ppr solid #e8e8e8;
                        color: #999;
                        background: url("../release/img/icon-noselect.png")
                            no-repeat right center;
                        background-size: 24px / $ppr 24px / $ppr;
                    }
                    .active {
                        background: url("../release/img/icon-select.png")
                            no-repeat right center;
                        background-size: 24px / $ppr 24px / $ppr;
                    }
                }
            }
        }
    }
}
.fix-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    p {
        text-align: center;
        color: #5e89ef;
        margin-bottom: 20px / $ppr;
    }
    .btn {
        background: #fff;
        padding: 24px / $ppr;
        span {
            display: block;
            background: #5e89ef;
            color: #fff;
            font-size: 30px / $ppr;
            line-height: 80px / $ppr;
            border-radius: 40px / $ppr;
            text-align: center;
        }
    }
}
.my-slide-enter,
.my-slide-leave-to {
    height: 0 !important;
}
</style>